import { render } from "./WebNav.vue?vue&type=template&id=11fbb1bf&scoped=true"
import script from "./WebNav.vue?vue&type=script&lang=js"
export * from "./WebNav.vue?vue&type=script&lang=js"

import "./WebNav.vue?vue&type=style&index=0&id=11fbb1bf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fbb1bf"]])

export default __exports__